<template>
  <v-dialog v-model="active" width="400">
    <template v-for="(_, scopedSlotName) in $scopedSlots" v-slot:[scopedSlotName]="slotData">
      <slot :name="scopedSlotName" v-bind="slotData"></slot>
    </template>
    <template v-for="(_, slotName) in $slots" v-slot:[slotName]>
      <slot :name="slotName"></slot>
    </template>
    <v-card>
      <v-card-title>Change Concentrations</v-card-title>
      <v-card-text>
        <v-autocomplete v-if="major === 'IDS'" v-model="primaryConcentration" :items="primaryConcentrationOptions" label="Primary Concentration" outlined />
        <v-autocomplete v-model="concentrations" :disabled="concentrationOptions.length === 0" :items="concentrationOptions" :label="major === 'IDS' ? 'Additional Concentrations (choose 2)' : 'Concentration(s)'" outlined multiple chips small-chips deletable-chips />
      </v-card-text>
      <v-card-actions>
        <v-btn :disabled="(major === 'IDS' && (primaryConcentration === '' || concentrations.length !== 2))" @click="save()" text>Save Changes</v-btn>
        <v-spacer />
        <v-btn text @click="active = false">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { ref, watch } from '@vue/composition-api'

export default {
  props: {
    major: {
      type: String,
      required: true
    },
    currentConcentrations: {
      type: Array,
      default: () => { return [] }
    }
  },
  setup (props, { root, emit }) {
    const active = ref(false)
    const settingServ = root.$feathers.service('student/reg-setting')

    const primaryConcentration = ref('')
    const primaryConcentrationOptions = ref([])

    const concentrations = ref([])
    const concentrationOptions = ref([])

    watch(() => props.major, async () => {
      const { data } = await settingServ.find({ query: { form: 'program', major: props.major, category: { $in: ['concentration', 'primary-concentration'] } } })
      for (const { category, options } of data) {
        if (category === 'concentration') {
          concentrationOptions.value = options
          if (props.currentConcentrations.length > 0) concentrations.value = props.currentConcentrations.filter(({ value: val }) => options.find(({ value }) => value === val))
        } else {
          primaryConcentrationOptions.value = options
          if (props.currentConcentrations.length > 0) primaryConcentration.value = props.currentConcentrations.find((val) => options.find(({ value }) => value === val)).value || ''
        }
      }
    })

    watch(concentrations, () => {
      if (props.major === 'IDS' && concentrations.value.length > 2) {
        concentrations.value.splice(2, 1)
      }
    })

    async function save () {
      const obj = [ ...concentrations.value ]
      if (props.major === 'IDS') {
        obj.splice(0, 0, primaryConcentration.value)
      }
      emit('save', obj)
      active.value = false
    }

    return {
      active,
      primaryConcentration,
      primaryConcentrationOptions,
      concentrations,
      concentrationOptions,
      save
    }
  }
}
</script>
